import { ETHNICITIES } from '../constants/ethnicities';

export function getEthnicityLegacyId(ethnicityName: string) {
  return Object.entries(ETHNICITIES).find(
    ([key, value]) => value.name === ethnicityName
  )?.[1].legacyId as string;
}
